(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('accountManagement.loggedOut', {
                url: '/logged-out',
                templateUrl: 'app/components/loggedOut/loggedOut.view.html',
                controller: 'LoggedOutController',
                controllerAs: 'vm'
            });
    }
})();
